<template>
  <div class="home" :starting="starting" ref="mainwindow">
    <Background :pump="null" :time="'day'"></Background>
    <Background id="bg_night" :pump="null" :time="'night'"></Background>
    <div class="bluebar"></div>
    <h1>Become a <b>SCADA Superhero<span :title="version">!</span></b></h1>
    <h2>Take on the challenge of looking after the water supply for Water Town</h2>
    <div class="challenge-container left-padding" ref="scroll" :size="size">
      <div class="challenge" v-for="(chl,chlidx) in challenges" :key="chl.number" v-show="!chl.hidden" :last="chlidx==challenges.length-1" :number="chl.number">
        <div :class="['lock', isLocked(chl.number) ? 'locked' : 'unlocked']" v-if="!config.offline || config.leaderboard"><span>{{chl.number}}</span><img class="locked-icon" v-if="isLocked(chl.number)" @click="$refs.unlock.showContactForm(chl.number,true)" src="@/assets/img/icon_lock.svg"><img v-if="!isLocked(chl.number)" src="@/assets/img/icon_unlock_black.svg"></div>
        <div class="challenge-title">Challenge <span>{{chl.number}}</span></div>
        <div class="challenge-length"><span>Length</span> {{chl.length}} mins</div>
        <div :class="['challenge-level', chl.level]">
          <div class="challenge-tab">{{chl.level}}</div>
          <div class="flex-separator"></div>
          <div v-if="hasScore(chl.number)" class="challenge-topscore">Your Top Score</div>
          <div v-if="hasScore(chl.number)" class="challenge-score">{{$store.state.scores[chl.number]}}</div>
          <div v-if="!hasScore(chl.number)" class="challenge-topscore no-score">Not Played</div>
        </div>
        <div class="challenge-desc" v-html="chl.desc"></div>
        <div class="challenge-buttons" v-if="!isLocked(chl.number)"><button @click="startChallenge(chl.number)" class="action-button">Start Challenge</button></div>
        <div class="challenge-buttons " v-if="isLocked(chl.number)">
          <button @click="$refs.unlock.showContactForm(chl.number,true)" v-if="!config.offline" class="action-button action-disabled">Unlock</button>
          <button @click="$refs.unlock.showContactForm(chl.number,true)" v-if="config.leaderboard" :title="'Finish challenge '+(chl.number-1)+' to unlock'" class="action-button action-disabled action-grayed" disabled>Challenge Locked</button>
        </div>
      </div>
      <div class="right-space">&nbsp;</div>
    </div>
    <div class="left-margin right-margin white-separator"></div>
    <div class="share-container" v-if="!config.offline">
      <button @click="share=true" class="action-button">Share Game</button>
    </div>
    <div class="simulation-points" v-if="config.leaderboard && $store.state.userData.totalScore > 0">
      <div class="score-label">Your Total<br>Score</div>
      <div class="score-value">{{$store.state.userData.totalScore}}</div>
      <div class="score-best" v-if="true">
        <div class="best-icon"></div>
        <div class="best-label">Top 10<br>Score</div>
      </div>
    </div>
    <div class="offline-container" v-if="config.offline">
      <button @click="showLeaderboard()" class="action-button yellow-button">View Top 10 Leaderboard</button>
      <button @click="$router.push('/results')" v-if="hasResults" class="action-button action-results">See All Results</button>
    </div>
    <div class="scroll-down hide-standalone">
      Scroll down to learn more about GE Digital's HMI/SCADA and analytics capabilities
      <br>
      <a @click="scrollDown()" ><img src="@/assets/img/arrow-down-small.svg" width="14" height="16"></a>
    </div>
    <div>
    </div>
    <Unlock @unlockchallenge="unlockChallenge($event)" ref="unlock"></Unlock>
    <Share :active="share" v-if="share" @hide="share=false"></Share>
    <UserForm v-if="showForm" :visible="showForm" @hide="showForm=false" :challenge="startedChallenge" @found="userFound($event)" @success="startChallenge($event)"></UserForm>
    <Alert ref="alert"></Alert>
    <a class="reset-session" v-if="config.offline && !config.leaderboard" @click="reset()">Reset session <img src="@/assets/img/reset.svg" width="22"></a>
    <a class="reset-session reset-user" v-if="config.leaderboard && userData('name')!=''" @click="reset()">
      <div class="player-info">
        <div class="player-label">Current Player</div>
        <div class="player-name">{{userData('name')}} <span class="player-company">{{userData('companyName')}}</span></div>
      </div>
      <div class="reset-icon">
        <img src="@/assets/img/reset.svg" width="22">
      </div>
    </a>
  </div>
</template>

<script>

import challenges from '@/assets/json/challenges.json'
import Share from '@/components/Share.vue'
import Unlock from '@/components/Unlock.vue'
import UserForm from '@/components/UserForm.vue'
import Alert from '@/components/Alert.vue'
import Background from '@/components/Background.vue'
import config from '@/config.js'

export default {
  name: 'home',
  data: function () {
    return {
      last: 0,
      form: false,
      share: false,
      loaded: false,
      unlock: '',
      challenges: challenges,
      startedChallenge: 1,
      starting: false,
      showForm: false,
      size: 0,
      config: config
    }
  },
  components: {
    Share,
    Unlock,
    Background,
    UserForm,
    Alert
  },
  mounted: function () {
    if (this.$store.state.lastDate > 0) {
      this.last = (new Date() - new Date(this.$store.state.lastDate * 1)) / 1000
    }
    if (window.Munchkin) {
      window.Munchkin.init('330-FCH-291')
      window.Munchkin.createTrackingCookie(true)
    }
    const scrollDiv = this.$refs.scroll
    const self = this
    scrollDiv.addEventListener('mousedown', function (ev) {
      scrollDiv.scrolling = true
      scrollDiv.ox = ev.clientX
      scrollDiv.oy = ev.clientY
      scrollDiv.style.cursor = 'ew-resize'
    })
    scrollDiv.addEventListener('mousemove', function (ev) {
      if (scrollDiv.scrolling && scrollDiv.scrollBy) {
        scrollDiv.scrollBy(-ev.movementX, 0)
      }
    })
    scrollDiv.addEventListener('mouseup', function (ev) {
      scrollDiv.ox = null
      scrollDiv.oy = null
      scrollDiv.scrolling = false
      scrollDiv.style.cursor = 'default'
    })
    const resizeEv = function (ev) {
      const container = document.querySelector('.challenge-container')
      if (!container) {
        return
      }
      let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
      if (window.parent.innerWidth < vw) {
        vw = window.parent.innerWidth
      }
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
      self.size = 0
      if (vw < 1800) {
        self.size = 1
      }
      if (vh < 900) {
        self.size = 1
      }
      if (vw < 1600) {
        self.size = 2
      }
      if (vh < 800) {
        self.size = 2
      }
      if (vw < 1400) {
        self.size = 3
      }
      if (vh < 750) {
        self.size = 3
      }
      if (vw < 1280) {
        self.size = 4
      }
      if (vh < 700) {
        self.size = 4
      }
      self.$nextTick(function () {
        const chlg = document.querySelector('.challenge[number="1"]')
        const st = window.getComputedStyle(chlg)
        const width = (parseFloat(st.width)) * 3 + (parseFloat(st.marginRight) * 2)
        const minPadding = 5 / 100
        const containerw = Math.round(width + vw * minPadding)
        if (vw > containerw) {
          container.setAttribute('full', 1)
        } else {
          container.setAttribute('full', 0)
        }
      })
    }
    window.addEventListener('resize', resizeEv)
    resizeEv()
  },
  props: {
    version: {
      type: String
    }
  },
  methods: {
    userData: function (field) {
      return this.$store.state.userData[field]
    },
    isBest: function () {
      let best = false
      const history = this.$store.state.userHistory.sort((a, b) => {
        return b.totalScore - a.totalScore
      })
      for (let index = 0; index < history.length; index++) {
        const hist = history[index]
        if (
          this.$store.state.userData.name.toLowerCase() === hist.name.toLowerCase() &&
          this.$store.state.userData.companyName.toLowerCase() === hist.companyName.toLowerCase()
        ) {
          best = index < 10
          break
        }
      }
      return best
    },
    showLeaderboard: function () {
      this.$router.push('/leaderboard')
    },
    userFound: function (chNum) {
      const playCh = 'Challenge ' + chNum
      const playNext = 'Next Challenge'
      const self = this
      let nextCh = 2
      if (this.$store.state.scores[2] > 0) {
        nextCh = 3
      }
      self.$refs.alert.show('Record Found', 'A previous record was found. Do you want to play challenge 1 again or your next challenge (' + nextCh + ')?', function (btn) {
        if (btn === playCh) {
          self.startChallenge(chNum)
        }
        if (btn === playNext) {
          self.startChallenge(nextCh)
        }
      }, [playCh, playNext])
    },
    startChallenge: function (num) {
      this.$forceUpdate()
      if (!this.$store.state.userData.name && config.leaderboard) {
        this.startedChallenge = num
        this.showForm = true
        return
      }
      num = (num === 1 ? 0 : num)
      this.starting = true
      const self = this
      setTimeout(function () {
        self.$router.push('/challenge/' + num + '/messages')
      }, 500)
    },
    unlockChallenge: function (number) {
      this.$forceUpdate()
    },
    hasScore: function (ch) {
      return !this.isLocked(ch) && this.$store.state.scores[ch] > 0
    },
    isLocked: function (ch) {
      return this.$store.state.locks[ch]
    },
    scrollDown: function () {
      parent.postMessage('scrolldown', '*')
    },
    reset: function () {
      const self = this
      self.$refs.alert.show('Reset Session?', 'Tapping "Reset" will reset the game to default values. All game progress you have made will be lost.', function (btn) {
        if (btn === 'Reset') {
          self.$refs.mainwindow.setAttribute('starting', 'true')
          self.$store.dispatch('clearUserSession')
          setTimeout(function () {
            self.$refs.mainwindow.setAttribute('starting', '')
            self.$forceUpdate()
          }, 1200)
        }
      }, ['Reset', 'Cancel'])
    }
  },
  computed: {
    hasResults: function () {
      const scores = this.$store.state.scores
      for (let i = 1; i < scores.length; i++) {
        if (scores[i] > 0) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss" >
.home{
  background-size: cover;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
#bg_night{
  opacity: 0;
  transition: opacity linear .5s;
}
.reset-session{
  position: absolute;
  right: 50px;
  top: 48px;
  padding: 0px 8px;
  font-size: 14px;
  color: #666;
  z-index: 1;
  cursor: pointer;
  height: 50px;
  line-height: 50px;
  background-color: #fff;
  color: #00B5E2;
  border-radius: 25px 25px;
  font-size: 18px;
  width: 240px;
  font-weight: bold;
  text-transform: uppercase;
  > img{
    vertical-align: middle;
    margin-left: 8px;
    display: inline-block;
  }
  &.reset-user{
    padding: 0 20px 0 40px;
    font-size: 12px;
    line-height: 1.4em;
    width: auto;
    display: flex;
    background-image: url(../assets/img/superhero.svg);
    background-position: 20px center;
    background-size: 28px 28px;
    .player-info{
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 12px;
      text-align: left;
      color: #1E2F46;
      border-right: 1px solid #1E2F4620;
      .player-label{
        font-weight: normal;
      }
      .player-name{
        font-size: 14px;
      }
      .player-company{
        color: #00B5E2;
        font-weight: bold;
        font-style: italic;
        text-transform: none;
      }
    }
    .reset-icon{
      display: inline-block;
      height: 100%;
      display: flex;
      align-items: center;
      padding-left: 12px;
    }
  }
}
.flex-separator{
  flex: 1 0;
}
h1{
  padding-top: 2vh;
  font-size: 52px;
  font-weight: normal !important;
  z-index: 1;
  b{
    font-style: italic;
  }
}
h2{
  z-index: 1;
  font-size: 22px;
  padding: 20px 0 50px 0;
  color: #8F9297;
  font-weight: normal !important;
}
.background{
  z-index: 0;
}
.background::after{
  content: ' ';
  width: 100%;
  height: 100%;
  background-image:linear-gradient(180deg, rgba(255,255,255,0.5), rgba(255,255,255,0));
  display: block;
  position:absolute;
}
.white-separator, .share-container, .offline-container{
  z-index: 1;
}
.simulation-points{
  z-index: 1;
  .score-label{
    text-align: right;
  }
}
.offline-container{
  position: absolute;
  left: 0;
  width: 100%;
  padding: 0 50px;
  bottom: 40px;
  .action-results{
    position: absolute;
    right: 50px;
  }
  .yellow-button{
    background-color: #F1C40F;
    color: #fff;
    padding: 0 90px 0 125px;
    background-image: url(../assets/img/cup-white.svg);
    background-size: 28px 28px;
    background-position: 85px center;
  }
}
.challenge-container{
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 2vw;
  margin-bottom: 0;
  scrollbar-color: transparent transparent;
  scrollbar-width: thin;
  &::-webkit-scrollbar{
    background-color: transparent;
    border-radius: 5px 5px;
    height: 3px;
  }
  &::-webkit-scrollbar-track{
    background-color: transparent;
    border-radius: 3px 3px;
  }
  &::-webkit-scrollbar-thumb{
    background-color: transparent;
    border-radius: 3px 3px;
  }
  .challenge{
    user-select: none;
    flex: 1 0 66vh;
    width: 66vh;
    max-height: 460px;
    height: 50vh;
    max-width: 500px;
    background-color: rgba(255,255,255,0.9);
    margin-right: 30px;
    border-radius: 10px 0 10px 10px;
    position: relative;
    text-align: left;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    > div {
      padding-right: 40px;
      padding-left: 40px;
    }
    .lock{
      position: absolute;
      top: 0;
      right: 0;
      width: 122px;
      height: 122px;
      background-image: url(../assets/img/lock-blue.svg);
      background-position: top right;
      background-size: contain;
      .locked-icon{
        cursor: pointer;
      }
      span{
        z-index: 1;
        pointer-events: none;
      }
    }
    .lock img{
      position: absolute;
      right: 23px;
      top: 17px;
      width: 28px;
    }
    .lock > span{
      position: absolute;
      top: 32px;
      right: 32px;
      font-weight: bold;
      color: #00B5E2;
    }
    .lock.unlocked{
      background-image: url(../assets/img/lock-gray.svg);
      > span{
        color: #fff;
        top: 38px;
      }
    }
    .lock.locked{
      .span{
        cursor:pointer;
      }
    }
  }
  .challenge-title{
    margin-top: 5vw;
    font-size:42px;
    span{
      font-weight: bold;
      font-style: italic;
    }
  }
  .challenge-length{
    background-image: url(../assets/img/Icon_Time.svg);
    background-repeat: no-repeat;
    background-position: -6px -1px;
    line-height: 26px;
    padding-left: 24px !important;
    margin-left: 40px;
    span{
      font-weight: bold;
      text-transform: uppercase;
    }
  }
  .challenge-level{
    display: flex;
    display: -webkit-box;
    justify-content: space-between;
    border-bottom: 2px solid #00A849;
    margin: 20px 0;
    height: 50px;
    > div{
      line-height: 50px;
      height: 50px;
    }
    .challenge-tab{
      margin: 0;
      margin-right: 20px;
      padding: 0 20px;
      background-color: #00A849;
      color: #fff;
      border-radius:5px 5px 0 0;
      box-sizing: border-box;
      text-transform: uppercase;
      font-weight: bold;
    }
    .challenge-topscore{
      text-transform: uppercase;
      padding-right: 20px;
      &.no-score{
        color: #ACACAC;
      }
    }
    .challenge-score{
      background-image: url(../assets/img/Trophy.svg);
      background-repeat: no-repeat;
      background-position: 0 13px;
      background-size: 20px 20px;
      padding-left: 30px;
      font-weight: bold;
      font-size: 24px;
    }
    &.Intermediate{
      border-bottom: 2px solid #FFCC01;
      .challenge-tab{
        background-color: #FFCC01;
      }
    }
    &.Hard{
      border-bottom: 2px solid #F45050;
      .challenge-tab{
        background-color: #F45050;
      }
    }
  }
  .challenge-desc{
    color: #8F9297;
    padding-bottom: 16px;
    font-size: 18px;
    min-height: 4em;
  }
  &[full='1']{
    padding-left: 0;
    padding-right: 0;
    justify-content:center;
    margin-left: auto;
    margin-right: auto;
    .challenge:nth-child(4){
      margin-right: 0;
    }
    .right-space{
      display:none;
    }
  }
  .challenge-buttons{
    display: flex;
  }
}
.home{
  .challenge-container{
    transition: margin-top ease-in-out 1s, opacity linear .5s;
  }
  h1, h2 {
    opacity: 1;
    transition: opacity linear .5s;
  }
  &[starting=true]{
    h1, h2 {
      opacity: 0;
    }
    .challenge-container{
      margin-top: 50vh;
      opacity: 0;
    }
    #bg_night{
      opacity: 1;
    }
  }
}
div[standalone='true'] .home{
  .challenge-container .challenge{
    border-radius: 10px;
  }
}
div[offline='true'] .home{
  .challenge-buttons{
    justify-content: center;
    button{
      min-width: 80%;
    }
  }
}
@media (max-width: 1400px){
  .home h1{
    font-size: 40px;
  }
  .reset-session{
    right: 30px;
    top: 30px;
    padding: 0px 8px;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    width: 200px;
  }
}
@media (max-height: 880px){
}
@media (max-height: 700px){
  #ge_game h1{
    font-size: 36px;
  }
  #ge_game h2{
    padding: 8px 20px 20px 20px;
  }
  .bluebar{
    height: 20px;
  }
  .white-separator{
    margin-bottom: 1vh;
  }
}
@media (max-height: 660px){
  h1{
    font-size: 32px !important;
  }
  h2{
    font-size: 18px !important;
    padding: 8px !important;
  }
}
.challenge-container[size='1'] {
  .challenge{
    width: 480px;
    max-width: 480px !important;
    flex: 1 0 480px;
    height: 400px;
    max-height: 400px;
    padding: 30px 0;
    > div{
      padding-right: 30px;
      padding-left: 30px;
    }
  }
  .challenge-length{
    margin-right: 30px;
    margin-left: 30px !important;
  }
  .challenge-title{
    font-size: 34px;
  }
  .challenge-level{
    font-size: 16px;
    height: 40px;
    margin: 14px 0;
    .challenge-topscore{
      font-size: 13px;
    }
    .challenge-score{
      font-size: 20px;
    }
    > div {
      height: 40px;
      line-height: 40px;
    }
  }
    .action-button{
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    padding: 0 32px;
  }
}
.challenge-container[size='2'] {
  .challenge{
    width: 410px;
    max-width: 410px !important;
    flex: 1 0 410px;
    height: 350px;
    max-height: 350px;
    padding: 24px 0;
    > div{
      padding-right: 24px;
      padding-left: 24px;
    }
  }
  .challenge-title{
    font-size: 32px;
  }
  .challenge-desc{
    font-size: 16px;
  }
  .challenge-length{
    margin-right: 24px;
    margin-left: 24px !important;
  }
  .challenge-level{
    font-size: 16px;
    height: 40px;
    margin: 14px 0;
    .challenge-topscore{
      font-size: 13px;
    }
    .challenge-score{
      font-size: 20px;
      background-size: 16px 16px;
    }
    > div {
      height: 40px;
      line-height: 40px;
    }
  }
    .action-button{
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    padding: 0 32px;
  }
}
.challenge-container[size='3'] {
  .challenge{
    width: 370px;
    max-width: 370px !important;
    flex: 1 0 370px;
    height: 300px;
    max-height: 300px;
    .lock{
      width: 98px;
      height: 98px;
      img{
        width: 20px;
        top: 14px;
        right: 18px;
      }
      span{
        top: 26px;
        right: 25px;
        font-size: 11px;
      }
      &.unlocked{
        span{
          top: 30px;
          right: 25px;
        }
      }
    }
    padding: 24px 0;
    > div{
      padding-right: 24px;
      padding-left: 24px;
    }
  }
  .challenge-length{
    margin-right: 24px;
    margin-left: 24px !important;
  }
  .challenge-title{
    font-size: 24px;
  }
  .challenge-desc{
    font-size: 14px;
  }
  .challenge-level{
    font-size: 12px;
    height: 36px;
    margin: 12px 0;
    .challenge-score{
      font-size: 20px;
      background-size: 14px 14px;
    }
    > div {
      height: 36px;
      line-height: 36px;
      font-size: 10px;
    }
  }
  .action-button{
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    padding: 0 28px;
  }
}
.challenge-container[size='4'] {
  .challenge{
    width: 330px;
    max-width: 330px !important;
    flex: 1 0 340px;
    height: 280px;
    max-height: 280px;
    .lock{
      width: 98px;
      height: 98px;
      img{
        width: 20px;
        top: 14px;
        right: 18px;
      }
      span{
        top: 26px;
        right: 25px;
        font-size: 11px;
      }
      &.unlocked{
        span{
          top: 30px;
          right: 25px;
        }
      }
    }
    padding: 24px 0;
    > div{
      padding-right: 24px;
      padding-left: 24px;
    }
  }
  .challenge-length{
    margin-right: 24px;
    margin-left: 24px !important;
  }
  .challenge-level{
    .challenge-tab{
      margin-right: 12px;
      padding: 0 16px;
    }
    .challenge-topscore{
      font-size: 10px;
      padding-right: 12px;
    }
    .challenge-score{
      font-size: 18px;
      background-size: 14px 14px;
    }
  }
  .challenge-title{
    font-size: 24px;
  }
  .challenge-desc{
    font-size: 12px;
  }
  .challenge-level{
    font-size: 12px;
    height: 36px;
    margin: 12px 0;
    .challenge-score{
      font-size: 20px;
    }
    > div {
      height: 36px;
      line-height: 36px;
    }
  }
  .action-button{
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    padding: 0 28px;
  }
}
</style>
